import {
  SupportTicketPriorityType,
  SupportTicketStatusType,
  SupportTicketTypeType,
  SupportTicketsResponsePayloadModel,
} from '../models/supportTicketsPayloadModel';
import { payloadToSupportTicketResponse } from '../mappers/payloadToSupportTicket';
import { SupportTicketsResponseModel } from '../models/supportTicketsModel';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

interface SupportTicketsListProps {
  host: string;
  token: string;
  assetId?: string;
  pageNumber?: number;
  pageSize?: number;
  priority?: SupportTicketPriorityType;
  sort?: string;
  status?: SupportTicketStatusType;
  type?: SupportTicketTypeType;
}

const getUrl = ({
  host,
  assetId,
  pageNumber,
  pageSize,
  priority,
  sort,
  status,
  type,
}: {
  host: string;
  assetId?: string;
  pageNumber?: number;
  pageSize?: number;
  priority?: SupportTicketPriorityType;
  sort?: string;
  status?: SupportTicketStatusType;
  type?: SupportTicketTypeType;
}) => {
  const params = new URLSearchParams();
  assetId && params.append('asset_id', assetId);
  pageNumber && params.append('page[number]', String(pageNumber));
  pageSize && params.append('page[size]', String(pageSize));
  priority && params.append('priority', priority);
  sort && params.append('page[sort]', sort);
  status && params.append('status', status);
  type && params.append('type', type);

  return `${host}/support-tickets?${params}`;
};

export const GetSupportTicketsList = async ({
  host,
  token,
  assetId,
  pageNumber,
  pageSize,
  priority,
  sort,
  status,
  type,
}: SupportTicketsListProps): Promise<SupportTicketsResponseModel> => {
  try {
    const url = getUrl({
      host,
      assetId,
      pageNumber,
      pageSize,
      priority,
      sort,
      status,
      type,
    });

    const options: AxiosRequestConfig = {
      url,
      method: 'GET',
      timeout: 10000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '2',
      },
    };

    const response = (await axios(options)) as AxiosResponse<SupportTicketsResponsePayloadModel>;
    return payloadToSupportTicketResponse(response.data);
  } catch (error: any) {
    throw new Error(error);
  }
};
